export default "__VITE_ASSET__ttuMTQZe__"